<template>
  <div class="flex flex-col flex-1">

    <h2 class="text-xl font-bold mb-4">
      <slot name="title" />
    </h2>

    <div class="grow">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
// import PrimaryLink from '../components/links/PrimaryLink.vue';
// import SecondaryLink from '../components/links/SecondaryLink.vue';
</script>